import UILockBadge from 'UIComponents/badge/UILockBadge';
import UIButton from 'UIComponents/button/UIButton';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LockedUpgradeButton = ({
  children,
  'data-test-id': dataTestId,
  disabled,
  responsive,
  size,
  upgradeKey,
  use
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);

  // TODO: this component is rendered inside UIDropdown's which doesn't have
  // styles "in menu" styles targeted at foundations components so they end
  // up center aligned. maintaining usage of UIButtons until foundations
  // Dropdown component is ready for prime time and menus and buttons can be
  // migrated at the same time.
  return /*#__PURE__*/_jsxs(UIButton, {
    "data-test-id": dataTestId,
    disabled: disabled,
    onClick: openUpgradeModal,
    responsive: responsive,
    size: size,
    use: use,
    children: [children, /*#__PURE__*/_jsx(UILockBadge, {})]
  });
};
export default LockedUpgradeButton;